@if (ref2 | async; as item) {
  <div class="row-flex page-references">
    <div class="container col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12 px-sm-20 reference_Container">
      <p class="reference1">{{item.headline}}</p>
      @if (item.largeparagraphcontent) {
        <p class="reference" [innerHTML]="item.largeparagraphcontent"></p>
      }
    </div>
    <!-- <div class="container col-flex-lg-12 col-flex-md-12 col-flex-sm-12 col-flex-xs-12 px-sm-20 largeparagraphcontent">
    <p class="reference" *ngIf="item.largeparagraphcontent" [innerHTML]="item.largeparagraphcontent"></p>
  </div> -->
</div>
}
